import { render, staticRenderFns } from "./project-step-contacts.vue?vue&type=template&id=308d3a9d&"
import script from "./project-step-contacts.vue?vue&type=script&lang=js&"
export * from "./project-step-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports